// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './LivePoll.css'

import { AlternativeList } from './AlternativeList/AlternativeList'
import type { Poll, Result as ResultType } from '../../../../types'
import { LastUpdatedTime } from './LastUpdatedTime/LastUpdatedTime'
import { VoteCounter } from './VoteCounter/VoteCounter'
import { breakpointToClassName } from '../../../../helpers/breakpointToClassName'
import { bem } from '../../../../helpers/bem'
import { LiveResult } from './LiveResult/LiveResult'
import { Branding } from '../../../../components/Branding/Branding'

type Props = {
  poll: Poll,
  onRegisterVote: any,
  hasVoted: boolean,
  voteError: ?Error,
  result: ?ResultType,
  resultError: ?Error,
  lastUpdatedTime?: Date,
  showResult?: boolean,
  resultMessage?: string,
  children?: ?any
}

export class LivePoll extends Component<Props> {
  render () {
    const {
      poll,
      onRegisterVote,
      hasVoted,
      voteError,
      resultError,
      result,
      lastUpdatedTime,
      showResult,
      resultMessage
    } = this.props
    const { currentBreakpoint } = this.context
    const title = poll ? poll.title : ''

    return (
      <div
        className={bem(
          styles.livePoll,
          breakpointToClassName(currentBreakpoint)
        )}
      >
        <Branding />
        <div className={styles.livePoll__header}>
          <h2 className={styles.livePoll__title}>{title}</h2>
        </div>

        <div className={styles.livePoll__content}>
          {!hasVoted && (
            <AlternativeList
              onAlternativeClicked={onRegisterVote}
              alternatives={poll.alternatives}
            />
          )}
          {hasVoted && (
            <LiveResult
              hasVoted={hasVoted}
              poll={poll}
              result={result}
              resultError={resultError}
              showResult={showResult}
              resultMessage={resultMessage}
            />
          )}
          {voteError &&
            'Det skjedde en feil ved registrering av stemme. Har du skrudd av informasjonskapsler i nettleseren din?'}
        </div>

        <footer className={styles.livePoll__footer}>
          {result && <VoteCounter voteCount={result.votes} />}
          {hasVoted && <LastUpdatedTime lastUpdatedTime={lastUpdatedTime} />}
        </footer>
        {this.props.children}
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/LivePoll.js